module.exports = __webpack_public_path__ + "static/media/post-office-header.59a00f9e.png";